import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import { changeFieldGeoTargetChangeTypeComparison } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectFieldGeoTarget } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';

import CountriesLayer from './CountriesLayer';

class GeoTargetTaskInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasShowContent: this.props.fieldGeoTarget.value.typeComparison !== null
    };
  }

  componentDidMount() {
    if (this.state.hasShowContent) {
      // eslint-disable-next-line no-undef
      $(`#collapseGeo`).collapse('show');
    }
  }

  render() {
    return (
      <React.Fragment>
        <div
          aria-multiselectable="true"
          className="panel-group"
          id="panelGroupGeotarget"
          role="tablist"
        >
          <section className="panel panel-default panel-heading_padding-large">
            <div className="panel-heading" role="tab">
              <h2 className="panel-title">
                <a
                  aria-controls="filter-collapseGeo"
                  aria-expanded="false"
                  className="dropdown-toggle dropdown-toggle-collapse collapsed"
                  data-toggle="collapse"
                  href="#collapseGeo"
                  role="button"
                >
                  <i className="fa fa-globe fa-fw" /> {t('Геотаргетинг')}
                </a>
              </h2>
            </div>
            <div
              aria-labelledby="headingOne"
              className="panel-collapse collapse"
              id="collapseGeo"
              role="tabpanel"
              aria-expanded="false"
            >
              <div className="panel-body bg-sub">
                <div className="form-group">
                  <p className="form-control-static text-center text-muted full-width">
                    {t(
                      'Здесь Вы можете задать настройки геотаргетинга, ваше задание будет доступно для выполнения только с ip адресов располоденных в тех локациях которые вы укажите.'
                    )}
                  </p>
                </div>
                <CountriesLayer reducerName={this.props.reducerName} />
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

GeoTargetTaskInputs.propTypes = {
  reducerName: PropTypes.string.isRequired,

  fieldGeoTarget: PropTypes.shape({
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  changeFieldGeoTargetChangeTypeComparison: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldGeoTarget: selectFieldGeoTarget(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldGeoTargetChangeTypeComparison: () =>
    dispatch(
      changeFieldGeoTargetChangeTypeComparison(props.reducerName, null, null, 1)
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeoTargetTaskInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/GeoTargetTaskInputs/GeoTargetTaskInputs.js